import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=35d5466e&scoped=true&"
import script from "./CreditCard.vue?vue&type=script&lang=ts&"
export * from "./CreditCard.vue?vue&type=script&lang=ts&"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=35d5466e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5466e",
  null
  
)

export default component.exports